
import { Component, Prop, Vue } from 'bits/vue'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzDivider, { OzDividerColorScheme } from 'library/v4/components/OzDivider.vue'

@Component({ components: { OzBox, OzDivider } })
export default class BillingCollectionItems extends Vue {
  /**
   * An array of texts to be rendered inside the box as items.
   */
  @Prop() items!: string[]

  OzBoxColors = OzBoxColors
  OzDividerColorScheme = OzDividerColorScheme
}
